import { getLegal, isRTL } from "@/lib/legal";
import { ShieldAlert } from "lucide-react";

// Blocking legal-consent modal shown before a new account is created.
// Localized into the signer's selected-country language (English fallback).
export default function LegalNoticeModal({ open, language = "English", busy = false, onAgree, onDecline }) {
  if (!open) return null;
  const t = getLegal(language);
  const dir = isRTL(language) ? "rtl" : "ltr";

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="legal-notice-modal">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />
      <div dir={dir} className="relative w-full max-w-md bg-[#0A0E27] border border-amber-500/30 rounded-3xl p-6 shadow-2xl">
        <div className="flex items-center gap-2 mb-3">
          <ShieldAlert className="w-6 h-6 text-amber-400" />
          <h2 className="text-lg font-bold text-[#F1F1F5]" data-testid="legal-notice-title">{t.noticeTitle}</h2>
        </div>
        <p className="text-sm text-[#C7C7CF] leading-relaxed mb-3">{t.noticeIntro}</p>
        <p className="text-sm text-amber-200/90 leading-relaxed mb-3">{t.noticeDontShare}</p>
        <p className="text-xs text-[#A0A0AB] mb-5">
          {t.noticeAgreeLine}{" "}
          <a href="/terms-of-service" target="_blank" rel="noreferrer" data-testid="legal-notice-read-terms" className="text-[#00D9FF] font-semibold underline">
            {t.readTerms}
          </a>
        </p>
        <div className="flex gap-3">
          <button data-testid="legal-decline-button" onClick={onDecline} disabled={busy}
            className="flex-1 h-11 rounded-full bg-white/5 border border-white/15 text-[#E4E4E7] font-semibold hover:bg-white/10 transition-colors disabled:opacity-50">
            {t.decline}
          </button>
          <button data-testid="legal-agree-button" onClick={onAgree} disabled={busy}
            className="flex-1 h-11 rounded-full bg-[#00D9FF] text-navy-ink font-bold hover:bg-[#33E4FF] transition-colors active:scale-95 disabled:opacity-50">
            {busy ? "…" : t.agree}
          </button>
        </div>
      </div>
    </div>
  );
}
